import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputAdornment,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Router, useNavigate } from "react-router-dom";
import IosSwitchMain from "../../../components/iosSwitchMain";
import {
  LocalizationProvider,
  DatePicker,
  DateTimePicker,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { showError, showToast } from "../../../constants/toasts";
import dayjs, { Dayjs } from "dayjs";
import { OFFER_STATUS, QUESTION_TYPE } from "../../../utils/enums";
import {
  getFromStorage,
  removeFromStorage,
  setToStorage,
  STORAGE_KEYS,
} from "../../../helpers";
import { useLazyGetPreviousQuestionQuery } from "../../../service/user";
import { isNumber, isValidNumber } from "../../../utils/validations";
import { Offer, OfferData } from "../../../types/General";
import {
  useCreateOfferMutation,
  useLazyCloneOfferQuery,
  useUpdateOfferMutation,
} from "../../../service/offer";
import CloseIcon from "@mui/icons-material/Close";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

interface QuestionOption {
  optionText: string;
}

interface QuestionData {
  question: string;
  inputType: string; // e.g., "text", "checkbox"
  isReused: boolean;
  options: QuestionOption[];
  label?: string;
}

const EVENT_TYPE = {
  PAID: "Paid",
  COMPLIMENTARY: "Complimentary",
};

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

interface OthersFormProps {
  alignment: string;
  offerDetails: Offer | null;
  updateId: string | undefined;
  isClone?: boolean;
  tabs: number;
  setTabs: Dispatch<SetStateAction<number>>;
  categoryTab: any;
  status: any;
  categoryName: string;
  categoryId: string;
}

function OthersForm({
  alignment,
  offerDetails,
  updateId,
  isClone,
  tabs,
  setTabs,
  categoryId,
  categoryName,
  categoryTab,
  status,
}: OthersFormProps) {
  const navigate = useNavigate();
  const [getQuestions] = useLazyGetPreviousQuestionQuery();
  const [createOffer] = useCreateOfferMutation();
  const [updateOffer] = useUpdateOfferMutation();
  const [cloneOffer] = useLazyCloneOfferQuery();

  const offerData = getFromStorage(STORAGE_KEYS.offerData);
  const parsedData: OfferData | null = offerData
    ? (JSON.parse(offerData) as OfferData)
    : null;

  const [isSpecificDateTime, setIsSpecificDateTime] = useState(false);
  const [isAdvanceBooking, setIsAdvanceBooking] = useState(false);
  const [isCancellationEnabled, setIsCancellationEnabled] = useState(false);
  const [isGuest, setIsGuest] = useState(false);

  const [valueTabs, setValueTabs] = React.useState(0);
  const [valueTabs1, setValueTabs1] = React.useState(0);
  const [questionsList, setQuestionsList] = useState<QuestionData[]>([]);
  const [currentOption, setCurrentOption] = useState<string>("");
  const [error, setError] = useState(false);
  const [selectedQuestions, setSelectedQuestions] = useState<any[]>([]);
  const [questionTabs, setQuestionTabs] = useState(0);
  const [textQuestions, setTextQuestions] = useState<QuestionData[]>([]);
  const [checkboxQuestions, setCheckboxQuestions] = useState<QuestionData[]>(
    []
  );
  const [radioQuestions, setRadioQuestions] = useState<QuestionData[]>([]);
  const [dateQuestions, setDateQuestions] = useState<QuestionData[]>([]);
  const [textAreaQuestions, setTextAreaQuestions] = useState<QuestionData[]>(
    []
  );
  const [cancellationAmount, setCancellationAmount] = useState("");
  const [cancellationHours, setCancellationHours] = useState("");
  const [selectedPeriod, setSelectedPeriod] = useState("Week");
  const [bookingPeriod, setBookingPeriod] = useState("");
  const [date, setDate] = useState<Dayjs | null>(null);
  const [time, setTime] = useState<Dayjs | null>(null);
  const [guests, setGuests] = useState("");
  const [nonMemberPrice, setNonMemberPrice] = useState("");
  const [selectedType, setSelectedType] = useState("Paid");
  const [loading, setLoading] = useState(false);
  const [openPrevQModal, setOpenPrevQModal] = useState(false);
  const [memberPrice, setMemberPrice] = useState("");
  const [guestType, setGuestType] = useState("event");

  const match = offerDetails?.advanceBookingPeriod?.match(/(\d+)\s*(\w+)/);

  const [type, setType] = useState("");
  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === EVENT_TYPE.COMPLIMENTARY) {
      setIsCancellationEnabled(false);
      setCancellationAmount("");
      setCancellationHours("");
      setNonMemberPrice("0");
      setMemberPrice("0");
    }
    if (event.target.value === EVENT_TYPE.PAID) {
      setNonMemberPrice("");
    }
    setSelectedType(event.target.value);
  };

  const isTypePaid = type === "paid";

  const [value, setValue] = useState<QuestionData>({
    inputType: "",
    question: "",
    options: [],
    isReused: false,
  });

  const handleChangePeriod = (event: SelectChangeEvent) => {
    const { value } = event.target;
    setSelectedPeriod(value);
  };

  const handleCheckboxChange = (q: any, checked: boolean) => {
    const questionData: QuestionData = {
      question: q?.label,
      inputType: q?.inputType,
      isReused: true, // or false depending on your requirement
      options: q?.options || [],
    };

    if (checked) {
      setSelectedQuestions((prev) => [...prev, questionData]);
    } else {
      setSelectedQuestions((prev) =>
        prev.filter((item) => item.question !== q?.label)
      );
    }
  };

  const handleSaveQuestion = () => {
    if (!selectedQuestions?.length) {
      showError("Please select questions");
      return;
    }

    const merged = [...questionsList, ...selectedQuestions];

    // remove duplicates by question text
    const unique = merged?.filter(
      (q, index, self) =>
        index === self?.findIndex((x) => x?.question === q?.question)
    );
    setValueTabs(0);
    setQuestionsList(unique);
    setOpenPrevQModal(false);
  };

  const handleChangeType = (e: SelectChangeEvent<string>) => {
    setValue({
      ...value,
      inputType: e.target.value,
      options: [], // reset options when type changes
    });
  };

  const handleChangeTab = (e: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);

    if (newValue === 1) {
      setOpenPrevQModal(true);
    }
  };

  const handleAddOption = () => {
    if (currentOption.trim()) {
      setValue((prev) => ({
        ...prev,
        options: [...prev.options, { optionText: currentOption.trim() }],
      }));
      setCurrentOption("");
    }
  };

  const handleSave = () => {
    if (!value.question.trim() || !value?.inputType) {
      showError("Please enter a question");
      return;
    }

    const formattedQuestion: QuestionData = {
      question: value.question.trim(),
      inputType:
        value.inputType === "Input" ? "text" : value.inputType.toLowerCase(),
      isReused: value.isReused,
      options: value.options, // already [{ optionText: string }]
    };

    setQuestionsList((prev) => [...prev, formattedQuestion]);

    setValue({
      question: "",
      inputType: "",
      isReused: false,
      options: [],
    });
    setCurrentOption("");
  };

  const handleEditQuestion = (idx: number) => {
    const q = questionsList[idx];
    setValue({
      question: q?.question || q?.label || "",
      inputType:
        q?.inputType === "text"
          ? "Input"
          : q?.inputType?.charAt(0)?.toUpperCase() + q?.inputType?.slice(1),
      isReused: q?.isReused,
      options: q?.options || [],
    });
    setQuestionsList((prev) => prev.filter((_, i) => i !== idx));
  };

  const handleDeleteQuestion = (idx: number) => {
    setQuestionsList((prev) => prev?.filter((_, i) => i !== idx));
  };

  const handleSubmit = () => {
    setError(true);

    if (isSpecificDateTime && (!date || !time)) {
      return;
    }

    if (isAdvanceBooking && !bookingPeriod) {
      return;
    }

    if (isCancellationEnabled && (!cancellationAmount || !cancellationHours)) {
      return;
    }

    if (isGuest && !guests) {
      return;
    }

    if (
      isGuest &&
      selectedType === "Paid" &&
      guestType === "event" &&
      !nonMemberPrice
    ) {
      return;
    }

    if (selectedType === "Paid" && !memberPrice) {
      return;
    }

    // if (!questionsList?.length) {
    //   showError("Please add questions");
    //   return;
    // }

    const newBody = {
      QuestionJson: questionsList,
      IsActive: alignment === OFFER_STATUS.ACTIVE ? true : false,
      IsArchive: alignment === OFFER_STATUS.ARCHIVE ? true : false,
      IsSpecificDateTime: isSpecificDateTime,
      IsAdvanceBooking: isAdvanceBooking,
      IsCancellationPolicy: isCancellationEnabled,
      ...(isGuest
        ? { IsdiningforOther: guestType === "dining" ? true : false }
        : {}),

      IsGuestAdded: isGuest,
      ...(isSpecificDateTime
        ? { SpecificOfferTime: time ? dayjs(time).toISOString() : "" }
        : {}),
      ...(isSpecificDateTime
        ? { SpecificOfferStartDate: date ? dayjs(date).toISOString() : "" }
        : {}),
      ...(isAdvanceBooking
        ? { AdvanceBookingPeriod: `${bookingPeriod} ${selectedPeriod}` }
        : {}),
      ...(isCancellationEnabled
        ? { CancellationAmountPerPerson: cancellationAmount || "" }
        : {}),
      ...(isCancellationEnabled
        ? { CancellationHours: cancellationHours || "" }
        : {}),
      ...(isGuest ? { NumberOfGuest: guests || "" } : {}),
      ...(isGuest && selectedType === EVENT_TYPE.PAID && guestType === "event"
        ? { NoMemberPrice: nonMemberPrice || "" }
        : {}),
      bookingPeriod: bookingPeriod,
      selectedPeriod: selectedPeriod,
      EventType: selectedType,
      MemberPrice: memberPrice,
    };

    const prevData = getFromStorage(STORAGE_KEYS.offerData);
    let parsedPrevData = {};

    if (prevData) {
      try {
        parsedPrevData = JSON.parse(prevData);
      } catch (err) {
        console.error("Error parsing stored offer data:", err);
      }
    }

    // Merge old and new data
    const mergedData = {
      ...parsedPrevData,
      ...newBody,
    };

    setToStorage(STORAGE_KEYS.offerData, JSON.stringify(mergedData));
    navigate("/manage-offer/preview-offer?mode=OTHERS", {
      state: {
        updateId,
        isClone,
        status,
        categoryTab,
        categoryId,
        categoryName,
      },
    });
  };

  const handleArchive = async () => {
    const formData = new FormData();

    const appendIfPresent = (key: string, value: any) => {
      if (value !== undefined && value !== null && value !== "") {
        formData.append(key, value);
      }
    };

    const appendArray = (key: string, arr?: any[]) => {
      if (Array.isArray(arr)) {
        arr.forEach((item) => {
          if (item !== undefined && item !== null && item !== "") {
            formData.append(key, item);
          }
        });
      }
    };

    appendIfPresent("Title", parsedData?.Title);
    appendIfPresent("Badge", parsedData?.Badge);
    appendIfPresent("Description", parsedData?.Description);
    appendIfPresent("Subtitle", parsedData?.Subtitle);
    appendIfPresent("CategoryId", parsedData?.CategoryId);
    appendIfPresent("OfferType", parsedData?.OfferType);
    appendIfPresent(
      "OfferDisplayStartDate",
      parsedData?.OfferDisplayStartDate
        ? dayjs(parsedData?.OfferDisplayTime).toISOString()
        : null
    );

    appendIfPresent(
      "OfferDisplayEndDate",
      parsedData?.OfferDisplayEndDate
        ? dayjs(parsedData?.OfferDisplayEndTime).toISOString()
        : null
    );

    appendIfPresent(
      "IsButterflyEffect",
      parsedData?.IsButterflyEffect ? "true" : "false"
    );

    appendIfPresent(
      "ButterflyEffectStartDate",
      parsedData?.ButterflyEffectStartDate
        ? dayjs(parsedData?.ButterflyEffectStartTime).toISOString()
        : null
    );

    appendIfPresent(
      "ButterflyEffectEndDate", // fixed the duplicate key name
      parsedData?.ButterflyEffecteEndDate
        ? dayjs(parsedData?.ButterflyEffectEndTime).toISOString()
        : null
    );

    appendIfPresent("ButtonName", parsedData?.ButtonName);
    appendArray("GroupsId", parsedData?.GroupsId);
    appendArray("TagsId", parsedData?.TagsId);
    appendArray("offerImages", parsedData?.offerImages);
    appendIfPresent("QuestionJson", JSON.stringify(questionsList || []));
    appendIfPresent(
      "OfferDisplayTime",
      parsedData?.OfferDisplayTime
        ? dayjs(parsedData?.OfferDisplayTime).format("HH:mm:ss")
        : null
    );

    appendIfPresent(
      "OfferDisplayEndTime",
      parsedData?.OfferDisplayEndTime
        ? dayjs(parsedData?.OfferDisplayEndTime).format("HH:mm:ss")
        : null
    );
    appendIfPresent(
      "ButterflyEffectStartTime",
      parsedData?.ButterflyEffectStartTime
        ? dayjs(parsedData?.ButterflyEffectStartTime).format("HH:mm:ss")
        : null
    );
    appendIfPresent(
      "ButterflyEffectEndTime",
      parsedData?.ButterflyEffectEndTime
        ? dayjs(parsedData?.ButterflyEffectEndTime).format("HH:mm:ss")
        : null
    );
    appendIfPresent(
      "IsActive",
      alignment === OFFER_STATUS.ACTIVE ? "true" : "false"
    );
    appendIfPresent(
      "IsArchive",
      alignment === OFFER_STATUS.ARCHIVE ? "true" : "false"
    );

    appendIfPresent(
      "SpecificOfferStartDate",
      date ? dayjs(time).format("HH:mm:ss") : null
    );

    appendIfPresent(
      "AdvanceBookingPeriod",
      `${bookingPeriod} ${selectedPeriod}`
    );

    appendIfPresent(
      "IsCancellationPolicy",
      isCancellationEnabled ? "true" : "false"
    );
    appendIfPresent("CancellationAmountPerPerson", cancellationAmount);
    appendIfPresent("CancellationHours", cancellationHours);
    appendIfPresent("IsGuestAdded", isGuest ? "true" : "false");
    appendIfPresent("NumberOfGuest", guests);
    appendIfPresent("NoMemberPrice", nonMemberPrice);
    appendIfPresent("EventType", selectedType);
    appendIfPresent("IsSpecificDateTime", parsedData?.IsSpecificDateTime);
    appendIfPresent("IsAdvanceBooking", parsedData?.IsAdvanceBooking);
    appendIfPresent("IsdiningforOther", parsedData?.IsdiningforOther);
    appendIfPresent("OfferId", updateId);

    if (!updateId || isClone) {
      try {
        setLoading(true);
        const response = await createOffer(formData).unwrap();
        setLoading(false);
        if (response?.status === 200) {
          removeFromStorage(STORAGE_KEYS.offerData);
          // navigate("/manage-offer/preview-offer-detail");
          showToast(response?.message || "");
          navigate("/manage-offer", {
            state: { status, categoryTab, categoryId, categoryName },
          });
        } else {
          showError(response?.message || "");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message || "");
        console.error(error);
      }
    } else {
      try {
        setLoading(true);
        const response = await updateOffer(formData).unwrap();
        setLoading(false);
        if (response?.status === 200) {
          removeFromStorage(STORAGE_KEYS.offerData);
          // navigate("/manage-offer/preview-offer-detail");
          showToast(response?.message || "");
          navigate("/manage-offer", {
            state: { status, categoryTab, categoryId, categoryName },
          });
        } else {
          showError(response?.message || "");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message || "");
        console.error(error);
      }
    }
  };

  const cloneOfferApi = async () => {
    try {
      const response = await cloneOffer({ offerId: updateId }).unwrap();
      if (response.status === 200) {
        removeFromStorage(STORAGE_KEYS.offerData);
        // navigate("/manage-offer/preview-offer-detail");
        showToast(response?.message || "");
        navigate("/manage-offer", {
          state: { status: 3, categoryTab, categoryId, categoryName },
        });
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const getPreviousQuestions = async () => {
    try {
      const response = await getQuestions({
        page: 1,
        search: "",
      }).unwrap();
      if (response.status === 200) {
        setCheckboxQuestions(
          response?.data?.filter(
            (q: any) => q?.inputType === QUESTION_TYPE.CHECKBOX
          )
        );
        setTextQuestions(
          response?.data?.filter(
            (q: any) => q?.inputType === QUESTION_TYPE.TEXT
          )
        );
        setRadioQuestions(
          response?.data?.filter(
            (q: any) => q?.inputType === QUESTION_TYPE.RADIO
          )
        );
        setTextAreaQuestions(
          response?.data?.filter(
            (q: any) => q?.inputType === QUESTION_TYPE.TEXTAREA
          )
        );
        setDateQuestions(
          response?.data?.filter(
            (q: any) => q?.inputType === QUESTION_TYPE.DATE
          )
        );
      } else {
        setCheckboxQuestions([]);
        setTextQuestions([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getPreviousQuestions();
  }, []);

  useEffect(() => {
    setIsGuest(parsedData?.IsGuestAdded ?? offerDetails?.isGuestAdded ?? false);
    setGuestType(
      parsedData?.IsdiningforOther || offerDetails?.isdiningforOther
        ? "dining"
        : "event"
    );
    setIsCancellationEnabled(
      parsedData?.IsCancellationPolicy ??
        offerDetails?.isCancellationPolicy ??
        false
    );
    setQuestionsList(
      parsedData?.QuestionJson
        ? parsedData?.QuestionJson
        : offerDetails?.questions
          ? offerDetails?.questions?.map((q) => ({
              question: q?.label,
              inputType: q?.inputType?.toLowerCase(),
              isReused: q?.isReused,
              options: q?.options ?? [],
            }))
          : []
    );
    setSelectedType(parsedData?.EventType ?? offerDetails?.eventType ?? "Paid");
    setDate(
      parsedData?.SpecificOfferStartDate
        ? dayjs(parsedData?.SpecificOfferStartDate)
        : offerDetails?.specificOfferStartDate
          ? dayjs(offerDetails?.specificOfferStartDate)
          : null
    );
    setTime(
      parsedData?.SpecificOfferTime
        ? dayjs(parsedData?.SpecificOfferTime)
        : offerDetails?.specificOfferStartDate
          ? dayjs(offerDetails?.specificOfferStartDate)
          : null
    );
    setBookingPeriod(parsedData?.bookingPeriod ?? match?.[1] ?? "");
    setSelectedPeriod(parsedData?.selectedPeriod ?? match?.[2] ?? "Week");
    setGuests(
      parsedData?.NumberOfGuest
        ? parsedData?.NumberOfGuest
        : offerDetails?.numberOfGuest
          ? String(offerDetails?.numberOfGuest)
          : ""
    );
    setNonMemberPrice(
      parsedData?.NoMemberPrice
        ? parsedData?.NoMemberPrice
        : offerDetails?.noMemberPrice
          ? String(offerDetails?.noMemberPrice)
          : ""
    );
    setCancellationAmount(
      parsedData?.CancellationAmountPerPerson
        ? parsedData?.CancellationAmountPerPerson
        : offerDetails?.cancellationAmountPerPerson
          ? String(offerDetails?.cancellationAmountPerPerson)
          : ""
    );
    setCancellationHours(
      parsedData?.CancellationHours
        ? parsedData?.CancellationHours
        : offerDetails?.cancellationHours
          ? String(offerDetails?.cancellationHours)
          : ""
    );
    setIsAdvanceBooking(
      parsedData?.IsAdvanceBooking ?? offerDetails?.isAdvanceBooking ?? false
    );
    setIsSpecificDateTime(
      parsedData?.IsSpecificDateTime ??
        offerDetails?.isSpecificDateTime ??
        false
    );
    setMemberPrice(
      parsedData?.MemberPrice
        ? parsedData?.MemberPrice
        : offerDetails?.memberPrice
          ? String(offerDetails?.memberPrice)
          : ""
    );
  }, []);

  return (
    <>
      <div className="section_title mn_hdng">
        <h2>Others</h2>
        <div className="btn_flex flx_end">
          <Button className="btn btn_primary" onClick={() => setTabs(0)}>
            Back
          </Button>

          {alignment === "archived" && (
            <Button
              className="btn btn_primary"
              onClick={() => {
                if (updateId) {
                  cloneOfferApi();
                } else {
                  handleArchive();
                }
              }}
            >
              Save & Exit
            </Button>
          )}
          <Button className="btn btn_primary" onClick={handleSubmit}>
            Preview
          </Button>
        </div>
      </div>

      <div className="gap_m avnc_bkng avnc_other_bkng">
        <div className="control_group has_border w_100">
          <div className="gap_m pb_15">
            <div className="control_group cncl_plcy w_50">
              <label>Specific Date & Time</label>
              <IosSwitchMain
                checked={isSpecificDateTime}
                onChange={(e) => setIsSpecificDateTime(e.target.checked)}
              />
            </div>
          </div>
          {isSpecificDateTime && (
            <div className="gap_m">
              <div className="w_50 control_group date_field">
                <label> Date</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className="form_control"
                    format="DD/MM/YYYY"
                    minDate={dayjs()}
                    value={date}
                    slotProps={{
                      textField: {
                        placeholder: "Date",
                        sx: {
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: "#9999", // change text & placeholder color
                            opacity: 1,
                          },
                        },
                      },
                    }}
                    onChange={(newValue) => setDate(newValue)}
                    slots={{
                      openPickerIcon: () => (
                        <img
                          src="/static/images/calendar_icon.svg"
                          alt="icon"
                        />
                      ),
                      // textField: (params) => (
                      //   <TextField
                      //     {...params}
                      //     fullWidth
                      //     placeholder="Start Date"
                      //     hiddenLabel
                      //   />
                      // ),
                    }}
                    desktopModeMediaQuery="(min-width:0px)"
                  />
                </LocalizationProvider>
                {error && !date ? (
                  <p className="err_msg">Date is required</p>
                ) : (
                  ""
                )}
              </div>
              <div className="w_50 control_group date_field">
                <label> Time</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    value={time}
                    onChange={(newValue) => {
                      if (date) {
                        setTime(
                          dayjs(date)
                            .hour(dayjs(newValue).hour())
                            .minute(dayjs(newValue).minute())
                        );
                      }
                    }}
                    slotProps={{
                      textField: {
                        placeholder: "Time",
                        sx: {
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: "#9999", // change text & placeholder color
                            opacity: 1,
                          },
                        },
                      },
                    }}
                    slots={{
                      openPickerIcon: () => (
                        <img
                          src="/static/images/calendar_icon.svg"
                          alt="icon"
                        />
                      ),
                    }}
                    disabled={!date}
                  />
                </LocalizationProvider>
                {error && !time ? (
                  <p className="err_msg">Time is required</p>
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
        </div>
        <div className="control_group has_border w_100">
          <div className="gap_m pb_15">
            <div className="control_group cncl_plcy w_50">
              <label>Advance Booking Period</label>
              <IosSwitchMain
                checked={isAdvanceBooking}
                onChange={(e) => setIsAdvanceBooking(e.target.checked)}
              />
            </div>
          </div>
          {isAdvanceBooking && (
            <div className="gap_m">
              <div className="advnc control_group w_100">
                <TextField
                  placeholder="Booking Period"
                  hiddenLabel
                  fullWidth
                  value={bookingPeriod}
                  id="title"
                  name="title"
                  className="text_field"
                  inputProps={{ maxLength: 5 }}
                  onChange={(val) => {
                    const { value } = val.target;
                    if (isNumber(value)) {
                      setBookingPeriod(value);
                    }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start" className="size_big">
                        <Select
                          className="dropse"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          inputProps={{
                            "aria-label": "Without label",
                          }}
                          displayEmpty
                          value={selectedPeriod}
                          name="page"
                          onChange={handleChangePeriod}
                        >
                          <MenuItem value="" disabled>
                            Select
                          </MenuItem>
                          <MenuItem value="Week">Weekly</MenuItem>
                          <MenuItem value="Month">Monthly </MenuItem>
                        </Select>
                      </InputAdornment>
                    ),
                  }}
                />
                {error && !bookingPeriod ? (
                  <p className="err_msg">Advance booking period is required</p>
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
        </div>
        <div className="control_group has_border w_100">
          <div className="gap_m pb_15">
            <div className="control_group cncl_plcy w_50">
              <label>Cancellation Policy</label>
              <IosSwitchMain
                checked={isCancellationEnabled}
                onChange={(e) => setIsCancellationEnabled(e.target.checked)}
              />
            </div>
          </div>
          {isCancellationEnabled && (
            <div className="gap_m">
              <div className="control_group w_50">
                <label htmlFor="cancellationAmount">
                  Cancellation Amount Per Person
                </label>
                <TextField
                  placeholder="Enter cancellation charges"
                  id="cancellationAmount"
                  hiddenLabel
                  fullWidth
                  value={cancellationAmount}
                  inputProps={{ maxLength: 5 }}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (isValidNumber(value)) {
                      setCancellationAmount(value);
                    }
                  }}
                />
                {error && !cancellationAmount ? (
                  <p className="err_msg">Cancellation amount is required</p>
                ) : (
                  ""
                )}
              </div>
              <div className="control_group w_50">
                <label htmlFor="cancellationHours">Cancellation Hours</label>
                <TextField
                  placeholder="Enter hours"
                  id="cancellationHours"
                  hiddenLabel
                  fullWidth
                  value={cancellationHours}
                  inputProps={{ maxLength: 5 }}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (isValidNumber(value)) {
                      setCancellationHours(value);
                    }
                  }}
                />
                {error && !cancellationHours ? (
                  <p className="err_msg">Cancellation hours is required</p>
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
        </div>
        <div className="control_group has_border w_100">
          <div className="gap_m pb_15">
            <div className="control_group cncl_plcy w_50">
              <label>Add Guest</label>
              <IosSwitchMain
                checked={isGuest}
                onChange={(e) => setIsGuest(e.target.checked)}
              />
            </div>
          </div>
          {isGuest && (
            <div className="gap_m">
              <div className="control_group w_100">
                <label>Guest Type</label>
                <RadioGroup
                  style={{ gap: 10 }}
                  row
                  value={guestType}
                  onChange={(e: any) => setGuestType(e.target.value)}
                >
                  <FormControlLabel
                    value="event"
                    control={<Radio />}
                    label="As Event"
                  />
                  <FormControlLabel
                    value="dining"
                    control={<Radio />}
                    label="As Dining"
                  />
                </RadioGroup>
              </div>

              <div className="control_group w_50">
                <label htmlFor="guests">No. of Guests</label>
                <TextField
                  placeholder="No. of Guests"
                  id="guests"
                  hiddenLabel
                  fullWidth
                  value={guests}
                  inputProps={{ maxLength: 5 }}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (isValidNumber(value)) {
                      setGuests(value);
                    }
                  }}
                />
                {error && !guests ? (
                  <p className="err_msg">No. of Guests is required</p>
                ) : (
                  ""
                )}
              </div>
              {selectedType === EVENT_TYPE.PAID && guestType === "event" ? (
                <div className="control_group w_50">
                  <label htmlFor="nonMemberPrice">Non-Member Price</label>
                  <TextField
                    placeholder="Non Member Price"
                    id="nonMemberPrice"
                    hiddenLabel
                    fullWidth
                    value={nonMemberPrice}
                    inputProps={{ maxLength: 5 }}
                    onChange={(e) => {
                      const { value } = e.target;
                      if (isValidNumber(value)) {
                        setNonMemberPrice(value);
                      }
                    }}
                  />
                  {error && !nonMemberPrice ? (
                    <p className="err_msg">Non-Member Price is required</p>
                  ) : (
                    ""
                  )}
                </div>
              ) : null}
            </div>
          )}
        </div>
        <div className="control_group has_border w_100">
          <div className="gap_m pb_15">
            <div className="control_group w_100">
              <label>Type</label>
              <FormControl className="paid_radio">
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="Paid"
                  name="radio-buttons-group"
                  value={selectedType}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="Paid"
                    control={<Radio />}
                    label="Paid"
                  />
                  <FormControlLabel
                    value="Complimentary"
                    control={<Radio />}
                    label="Complimentary"
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </div>
          {selectedType === EVENT_TYPE.PAID && (
            <div className="gap_m">
              <div className="control_group w_100">
                <label htmlFor="memberPrice">Member Price</label>
                <TextField
                  placeholder="Enter Price"
                  id="memberPrice"
                  hiddenLabel
                  value={memberPrice}
                  inputProps={{ maxLength: 5 }}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (isNumber(value)) {
                      setMemberPrice(value);
                    }
                  }}
                />
                {error && !memberPrice ? (
                  <p className="err_msg">Member Price is required</p>
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
        </div>

        <Box className="custom_tabs2 mt_40 mb_30" sx={{ width: "100%" }}>
          <Tabs
            aria-label="basic tabs example"
            className="custom_tabs_links"
            value={valueTabs}
            onChange={handleChangeTab}
          >
            <Tab {...a11yProps(0)} label="+ Add Custom" />
            <Tab {...a11yProps(1)} label="+ Add Previous Questions" />
          </Tabs>
        </Box>
        <div>
          <div className="control_group w_100 cstm_mn">
            <div className="gap_m">
              <div className="control_group w_50">
                <label htmlFor="demo-simple-select">Select Type</label>
                <Select
                  className="dropse"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                  name="inputType"
                  value={value.inputType}
                  onChange={handleChangeType}
                >
                  <MenuItem value="" disabled>
                    Select Type
                  </MenuItem>
                  <MenuItem value="Checkbox">Checkbox</MenuItem>
                  <MenuItem value="Input">Input</MenuItem>
                  <MenuItem value="TextArea">TextArea</MenuItem>
                  <MenuItem value="Radio">Radio</MenuItem>
                  <MenuItem value="Date">Date</MenuItem>
                </Select>
              </div>

              <div className="control_group w_50">
                <label htmlFor="question">Enter Question</label>
                <TextField
                  placeholder="Question"
                  id="question"
                  hiddenLabel
                  fullWidth
                  value={value.question}
                  onChange={(e) =>
                    setValue((prev) => ({
                      ...prev,
                      question: e.target.value,
                    }))
                  }
                />
              </div>
            </div>
          </div>
          {value?.inputType === "Checkbox" || value?.inputType === "Radio" ? (
            <div className="control_group w_100">
              <label htmlFor="optionText">Add Options</label>
              <TextField
                id="optionText"
                placeholder="Option Text"
                hiddenLabel
                fullWidth
                value={currentOption}
                onChange={(e) => setCurrentOption(e.target.value)}
              />
            </div>
          ) : null}

          {value.options.length > 0 && (
            <FormGroup style={{ marginTop: 10 }}>
              {value?.options?.map((opt, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 4,
                  }}
                >
                  <span style={{ fontSize: 14, marginRight: 8 }}>{i + 1}.</span>
                  <span>{opt?.optionText}</span>
                </div>
              ))}
            </FormGroup>
          )}

          <div className="control_group w_100 chkbx_mn">
            <FormControlLabel
              control={
                <Checkbox
                  checked={value?.isReused}
                  onChange={(e) =>
                    setValue((prev) => ({
                      ...prev,
                      isReused: e.target.checked,
                    }))
                  }
                />
              }
              name="remember"
              label="Save this question for other offers"
            />
            {value.inputType === "Checkbox" || value.inputType === "Radio" ? (
              <Button className="btn btn_primary" onClick={handleAddOption}>
                + Add Option
              </Button>
            ) : null}
          </div>

          <Button
            className="btn btn_primary"
            sx={{ marginBottom: "20px" }}
            onClick={handleSave}
          >
            Save
          </Button>

          {questionsList?.length > 0 && (
            <div style={{ marginTop: "10px" }}>
              <h2 style={{ marginBottom: "20px" }}>Saved Questions</h2>
              {questionsList?.map((q: any, idx) => (
                <div
                  key={idx}
                  style={{
                    marginBottom: 10,
                    borderRadius: 8,
                    padding: "8px 12px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <strong style={{ fontSize: "16px" }}>
                        {`${idx + 1}. ${q?.question || q?.label}`}
                      </strong>{" "}
                      ({q?.inputType})
                    </div>
                    <div>
                      <IconButton
                        className="edit_icon"
                        onClick={() => handleEditQuestion(idx)}
                      >
                        <img src="/static/images/edit2_icon.svg" alt="icon" />
                      </IconButton>

                      <IconButton
                        className="edit_icon"
                        onClick={() => handleDeleteQuestion(idx)}
                      >
                        <img
                          src="/static/images/trash2_icon.svg"
                          alt="Delete"
                        />
                      </IconButton>
                    </div>
                  </div>

                  {(q?.inputType?.toLowerCase() === "checkbox" ||
                    q?.inputType?.toLowerCase() === "radio") && (
                    <ul className="options_list">
                      {q?.options?.map((opt: any, i: number) => (
                        <li
                          key={i}
                          style={{ marginLeft: 30, marginTop: 5 }}
                          className="option_item"
                        >
                          {opt?.optionText}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        <Modal
          className="modal commissionOffer_modal build_offer_modal"
          open={openPrevQModal}
          onClose={() => {
            setValueTabs(0);
            setOpenPrevQModal(false);
          }}
        >
          <div className="modal-dialog" style={{ minWidth: "90%" }}>
            <div className="modal-body">
              <div className="modal_title text_center mb_30">
                <h2>Add Previous Questions</h2>

                <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
                  <div className="btn_flex flx_end">
                    <Button
                      className="btn btn_primary"
                      onClick={handleSaveQuestion}
                    >
                      Save
                    </Button>
                  </div>

                  <div
                    role="button"
                    tabIndex={0}
                    className="btn-close"
                    onClick={() => {
                      setOpenPrevQModal(false);
                      setValueTabs(0);
                    }}
                  >
                    <CloseIcon />
                  </div>
                </div>
              </div>
              <div className="control_group w_100">
                <CustomTabPanel value={valueTabs} index={1}>
                  <div className="cards crds_mn">
                    <Box className="custom_tabs2  mb_30" sx={{ width: "100%" }}>
                      <Tabs
                        aria-label="basic tabs example"
                        className="custom_tabs_links"
                        value={questionTabs}
                        onChange={(e, newValue) => setQuestionTabs(newValue)}
                      >
                        <Tab {...a11yProps(0)} label="Checkbox" />
                        <Tab {...a11yProps(1)} label="Text" />
                        <Tab {...a11yProps(2)} label="Radio" />
                        <Tab {...a11yProps(3)} label="TextArea" />
                        <Tab {...a11yProps(4)} label="Date" />
                      </Tabs>
                    </Box>

                    <CustomTabPanel value={questionTabs} index={0}>
                      <FormGroup className="prvs_qstn_mn">
                        {checkboxQuestions?.length > 0 && (
                          <div className="d_flx1">
                            {checkboxQuestions?.map((q: any, idx) => (
                              <div key={idx} className="question_card">
                                {/* Checkbox + Title */}
                                <div className="question_header">
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={selectedQuestions.some(
                                          (item) => item.question === q?.label
                                        )}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            q,
                                            e.target.checked
                                          )
                                        }
                                      />
                                    }
                                    label={
                                      <h3 className="question_title">
                                        Question {idx + 1}
                                      </h3>
                                    }
                                  />
                                </div>

                                {/* Question Text */}
                                <p className="question_label">
                                  <strong>{q?.label}</strong>{" "}
                                  <span className="input_type">
                                    ({q?.inputType})
                                  </span>
                                </p>

                                {/* Options List */}
                                {q?.options?.length > 0 && (
                                  <ul className="options_list">
                                    {q?.options?.map(
                                      (opt: QuestionOption, i: number) => (
                                        <li key={i} className="option_item">
                                          {opt?.optionText}
                                        </li>
                                      )
                                    )}
                                  </ul>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      </FormGroup>
                    </CustomTabPanel>

                    <CustomTabPanel value={questionTabs} index={1}>
                      <FormGroup className="prvs_qstn_mn">
                        <div className="d_flx1">
                          {textQuestions?.map((q: any, i) => (
                            <div key={i} className="question_card">
                              <div className="question_header">
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={selectedQuestions.some(
                                        (item) => item.question === q?.label
                                      )}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          q,
                                          e.target.checked
                                        )
                                      }
                                    />
                                  }
                                  label={<h2>Question {i + 1}</h2>}
                                />
                              </div>
                              <p>{q?.label}</p>
                            </div>
                          ))}
                        </div>
                      </FormGroup>
                    </CustomTabPanel>

                    <CustomTabPanel value={questionTabs} index={2}>
                      <FormGroup className="prvs_qstn_mn">
                        {radioQuestions?.length > 0 && (
                          <div className="d_flx1">
                            {radioQuestions?.map((q: any, idx) => (
                              <div className="question_card">
                                <div className="question_header">
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={selectedQuestions?.some(
                                          (item) => item.question === q?.label
                                        )}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            q,
                                            e.target.checked
                                          )
                                        }
                                      />
                                    }
                                    label={<h2>Question {idx + 1}</h2>}
                                  />
                                </div>
                                <p style={{ fontSize: "16px" }}>{q?.label}</p> (
                                {q.inputType})
                                <ul style={{ marginTop: "10px" }}>
                                  {q?.options?.map(
                                    (opt: QuestionOption, i: number) => (
                                      <li style={{ marginLeft: 20 }} key={i}>
                                        {opt?.optionText}
                                      </li>
                                    )
                                  )}
                                </ul>
                              </div>
                            ))}
                          </div>
                        )}
                      </FormGroup>
                    </CustomTabPanel>

                    <CustomTabPanel value={questionTabs} index={3}>
                      <FormGroup className="prvs_qstn_mn">
                        <div className="d_flx1">
                          {textAreaQuestions?.map((q: any, i) => (
                            <div key={i} className="question_card">
                              <div className="question_header">
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={selectedQuestions?.some(
                                        (item) => item?.question === q?.label
                                      )}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          q,
                                          e.target.checked
                                        )
                                      }
                                    />
                                  }
                                  label={<h2>Question {i + 1}</h2>}
                                />
                              </div>
                              <p>{q?.label}</p>
                            </div>
                          ))}
                        </div>
                      </FormGroup>
                    </CustomTabPanel>

                    <CustomTabPanel value={questionTabs} index={4}>
                      <FormGroup className="prvs_qstn_mn">
                        <div className="d_flx1">
                          {dateQuestions?.map((q: any, i) => (
                            <div key={i} className="question_card">
                              <div className="question_header">
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={selectedQuestions?.some(
                                        (item) => item?.question === q?.label
                                      )}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          q,
                                          e.target.checked
                                        )
                                      }
                                    />
                                  }
                                  label={<h2>Question {i + 1}</h2>}
                                />
                              </div>
                              <p>{q?.label}</p>
                            </div>
                          ))}
                        </div>
                      </FormGroup>
                    </CustomTabPanel>
                  </div>
                </CustomTabPanel>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
}

export default OthersForm;
